import { api } from "./apiConfig";

// Sign up
export const signUp = async (data) => {
  try {
    const response = await api.post("/auth/signup", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Sign in
export const signIn = async (data) => {
  try {
    const response = await api.post("/auth/signin", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Validate session
export const validateSession = async () => {
  try {
    const response = await api.post("/auth/validate-session");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Logout
export const logout = async () => {
  try {
    const response = await api.post("/auth/logout");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Forgot password
export const forgotPassword = async (data) => {
  try {
    const response = await api.post("/auth/forgot-password", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Reset password
export const resetPassword = async (token, data) => {
  try {
    const response = await api.post(
      `/auth/reset-password?token=${token}`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Verify email change
export const verifyEmailChange = async (token) => {
  try {
    const response = await api.get(`/auth/verify-email-change?token=${token}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Resend verification email (now sends a code, not a link)
export const resendVerificationEmail = async (data) => {
  try {
    const response = await api.post("/auth/resend-verify-email-link", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Verify email with a 6-digit typed code (inline OTP flow)
export const verifyEmailWithCode = async (code) => {
  try {
    const response = await api.post("/auth/verify-email-code", { code });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Resend email change verification
export const resendEmailChangeVerification = async () => {
  try {
    const response = await api.post("/auth/resend-email-change-verification");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Cancel email change
export const cancelEmailChange = async () => {
  try {
    const response = await api.delete("/auth/cancel-email-change");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Google callback - Commented out, not ready for production
/* 
export const googleCallback = async (code, codeVerifier, path) => {
  try {
    const response = await api.post(`/auth/google-callback?path=${path}`, {
      code,
      codeVerifier,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
*/

// Logout all sessions
export const logoutAllSessions = async (password) => {
  try {
    const response = await api.post("/auth/logout-all-sessions", { password });
    return response.data;
  } catch (error) {
    throw error;
  }
};
